export default __webpack_public_path__ + "static/media/kokilai.7b6370f5.ttf";